import { digits } from './constants';
export const asciiRegExpChars = 'a-zA-Z0-9!"#$%&\'()*+,-./:;<=>?@[\\]^_`{|}~';
export const usernameRegExpChars = 'A-z_0-9+-.@';
export const regExp = {
    ascii: new RegExp(`^[${asciiRegExpChars}]$`),
    digits: new RegExp(`^[${digits}]*$`),
    integer: /^\d*$/,
    negativeNumber: /^-?\d*([.,]\d*)?$/,
    positiveNumber: /^\d*([.,]\d*)?$/,
    positiveNumberTwoSymbolsAfterDot: /^\d*([.,]\d{0,2})?$/,
    percentage: /^\d{1,2}$|^100$/,
    sharpLink: /^#(.+)/,
    ports: /^(0|[1-9][0-9]{0,3}|[1-5][0-9]{4}|6[0-4][0-9]{3}|65[0-4][0-9]{2}|655[0-2][0-9]|6553[0-5])$/,
    username: new RegExp(`^[${usernameRegExpChars}]{5,150}$`),
    usernameSoft: new RegExp(`^[${usernameRegExpChars}]{1,150}$`),
    usernameSoftForRegistration: new RegExp(`^[${usernameRegExpChars}]{1,16}$`),
    safeName: /^[A-Za-zА-Яа-яЁ-ё -]+$/,
    password: new RegExp(`^[${asciiRegExpChars}]{6,18}$`),
    passwordSoft: new RegExp(`^[${asciiRegExpChars}]{1,18}$`),
    phoneSoft: /^[\d\s()+-]+$/,
    email: /^.*?@.*?\..{2,}$/i,
    sendernameSMS: /^[a-zA-Z0-9!?\-_.()]{4,11}$/i,
    sendernameVoice: /^\d{6,15}$/,
    viberButtonUrl: /^(https?|viber|tel|callto):/,
    otpSettingsTitle: /^.{1,50}$/,
    innSoft: /^\d{0,12}$/,
    inn: /^\d{10}$|^\d{12}$/,
    bicSoft: /^\d{0,9}$/,
    bic: /^\d{9}$/,
    kppSoft: /^\d{0,9}$/,
    kpp: /^\d{9}$/,
    ogrnSoft: /^\d{0,15}$/,
    ogrn: /^\d{13}$|^\d{15}$/,
    okpoSoft: /^\d{0,10}$/,
    okpo: /^\d{8}$|^\d{10}$/,
    ksSoft: /^\d{0,20}$/,
    ks: /^\d{20}$/,
    addressIndex: /^\d{0,6}$/,
    fileType: /^([a-z]+\/[a-z]+)$/,
    html: /<[^>]*>/,
    varchar: /^.{1,255}$/
};
//# sourceMappingURL=regexp.js.map